import { useAtom, useAtomValue } from 'jotai'
import { useEffect, useRef } from 'react'
import {
  selectedAssetFeatureAtom,
  selectedAssetIdAtom,
  propertyAssetTypeAtom,
} from '@app/state/propertyAtoms'
import { usePropertyMap } from '@app/contexts/ModuleMapContexts/PropertyMapContext'
import { loadAssetFeature } from '@app/contexts/ModuleMapContexts/utils/layers'
import { logger } from '@app/utils/logger'

export const usePropertyMapEffects = () => {
  const { fitToBoundsOfFeature, map } = usePropertyMap()
  const selectedAssetId = useAtomValue(selectedAssetIdAtom)
  const assetType = useAtomValue(propertyAssetTypeAtom)
  const [selectedAssetFeature, setSelectedAssetFeature] = useAtom(selectedAssetFeatureAtom)

  const isLoadingRef = useRef(false)
  const lastLoadedIdRef = useRef<string | null>(null)

  useEffect(() => {
    if (!map || !assetType || !selectedAssetId) {
      return
    }

    if (isLoadingRef.current || lastLoadedIdRef.current === selectedAssetId) {
      return
    }

    isLoadingRef.current = true

    loadAssetFeature(assetType, selectedAssetId)
      .then((data) => {
        if (data) {
          setSelectedAssetFeature(data)
          lastLoadedIdRef.current = selectedAssetId
        }
      })
      .catch((error) => {
        logger.error('Failed to load asset feature:', error)
        setSelectedAssetFeature(null)
      })
      .finally(() => {
        isLoadingRef.current = false
      })
  }, [selectedAssetId, assetType, map, setSelectedAssetFeature])

  useEffect(() => {
    if (selectedAssetFeature && map) {
      requestAnimationFrame(() => {
        fitToBoundsOfFeature(selectedAssetFeature as GeoJSON.Feature, {
          usePadding: true,
        })
      })
    }
  }, [fitToBoundsOfFeature, selectedAssetFeature, map])
}
